import { render } from "./QuestaoSelecoesComponent.vue?vue&type=template&id=3ead41a2&scoped=true&ts=true"
import script from "./QuestaoSelecoesComponent.vue?vue&type=script&lang=ts"
export * from "./QuestaoSelecoesComponent.vue?vue&type=script&lang=ts"

import "./QuestaoSelecoesComponent.vue?vue&type=style&index=0&id=3ead41a2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ead41a2"]])

export default __exports__